import React from 'react';
import { FilterProps } from '../index';
import { MainFiltersCard } from './common/MainFilterCard';
import { AlphabeticallyGroupedOptions } from './common/AlphabeticallyGroupedOptions';

export const CountriesFilter = (props: FilterProps) => (
  <MainFiltersCard title="Countries" {...props}>
    <AlphabeticallyGroupedOptions {...props} key="CountriesFilter-container" />
  </MainFiltersCard>
);
